var React = require('react');

function InfoCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0zm0 22C6.5 22 2 17.5 2 12S6.5 2 12 2s10 4.5 10 10-4.5 10-10 10zm0-12c.6 0 1 .4 1 1v6c0 .6-.4 1-1 1s-1-.4-1-1v-6c0-.6.4-1 1-1zm0-4c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1z"}));
}

InfoCircle.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = InfoCircle;

InfoCircle.default = InfoCircle;
